// TODO: delete this file when the flag getGroupAndUserNamesEnabled is deleted
// since all uses of this call will be redirected to getGroupAndUserNames

import { Module } from '../Module';
import { GetUserNamesRequest, IGetUserNamesResult } from '../ServerApi/requests/GetUserNamesRequest';
import { IUserName } from '../ServerApi/types/IUser';
import { FetcherFactory } from '../services/FetcherFactory';
import { Resource } from './Resource';

export class UserNames extends Resource<IUserName> {

  public static $inject = ['FetcherFactory'];

  constructor(FetcherFactory: FetcherFactory) {
    super(FetcherFactory.getServerResourceFetcher(
      GetUserNamesRequest,
      (result: IGetUserNamesResult) => result.users));
  }

}

Module.instance().service('UserNames', UserNames);
